var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass: "logo-loading d-flex align-center justify-center",
          style: { minHeight: _vm.mH }
        },
        [
          _vm.showLogo
            ? _c(
                "div",
                {
                  staticClass: "logo-loading__logo-wrap",
                  style: _vm.logoStyle
                },
                [
                  _c("img", {
                    staticClass: "logo-loading__logo logo-loading__logo--ghost",
                    class: {
                      "logo-loading__logo--outlined": _vm.logoNeedsOutline
                    },
                    attrs: { src: _vm.logoSource, alt: "" },
                    on: { error: _vm.onImageError }
                  }),
                  _c("img", {
                    staticClass: "logo-loading__logo logo-loading__logo--fill",
                    class: {
                      "logo-loading__logo--outlined": _vm.logoNeedsOutline
                    },
                    attrs: {
                      src: _vm.logoSource,
                      alt: "",
                      "aria-hidden": "true"
                    },
                    on: { error: _vm.onImageError }
                  })
                ]
              )
            : _c("v-progress-circular", {
                staticClass: "logo-loading__spinner",
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 40,
                  width: 3
                }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }